export default class Api {
  static getDocuments() {
    const request = new Request(window.CE_HUB_API_URL + `/user/documents/W-2`, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json',
        Authorization: localStorage.getItem('token')
      })
    });
    return fetch(request)
      .then(response => {
        return response.json();
      })
      .catch(error => {
        console.log(error);
        return error;
      });
  }
}



// WEBPACK FOOTER //
// ./src/components/TaxDocuments/ducks/operations.js